module.exports = __webpack_public_path__ + "img/crkvaW.771a63de.png";